(ns frontend.view.settings2.sso.event
  (:require
   [re-frame.core :as rf]
   [frontend.view.settings2.sso.model :as model]
   [frontend.controller.websocket.event :as ws]
   [frontend.global-events.toast :as toast]
   [common.util :as cu]
   [common.localization :as loc]
   [potpuri.core :as p]
   [clojure.set :as set]
   [frontend.state.current-session :as session]))

(def trim-v [rf/trim-v])

(def inject-tenant-interceptor
  (rf/->interceptor
   {:id     ::inject-tenant
    :before (fn [args]
              (let [tenant @session/tenant]
                (assoc-in args [:coeffects :tenant] tenant)))}))

(rf/reg-event-fx
 ::load-configs
 [trim-v]
 (fn [_]
   {::ws/send {:id         :login-page-config/get-all
               :on-success [::load-configs-success]
               :on-error   [::load-configs-error]}}))

(rf/reg-event-fx
 ::load-configs-success
 [trim-v]
 (fn [{:keys [db]} [resp]]
   {:db (-> db
            (assoc-in model/configs-full-path (:body resp))
            (assoc-in model/initialized?-full-path true)
            (assoc-in model/loading-error?-full-path false))}))

(rf/reg-event-fx
 ::load-configs-error
 [trim-v]
 (fn [{:keys [db]} _]
   {:db (-> db
            (assoc-in model/initialized?-full-path true)
            (assoc-in model/loading-error?-full-path true))}))

(rf/reg-event-db
 ::show-delete-modal
 [trim-v]
 (fn [db [config-id]]
   (let [config (->> (get-in db model/configs-full-path)
                     (cu/find-one :db/id config-id))]
     (assoc-in db model/delete-modal-full-path {:config config}))))

(rf/reg-event-db
 ::hide-delete-modal
 [trim-v]
 (fn [db _]
   (p/dissoc-in db model/delete-modal-full-path)))

(rf/reg-event-fx
 ::delete-config
 [trim-v]
 (fn [_ [config]]
   {:fx [[:dispatch [::hide-delete-modal]]
         [::ws/send {:id         :entity/disable!
                     :body       {:entity-id (:db/id config)}
                     :on-success [::load-configs]
                     :on-error   [::delete-config-error (:db/id config)]}]]}))

(rf/reg-event-db
 ::delete-config-error
 [trim-v]
 (fn [db [resp]]
   (js/console.log "Delete config error " resp)
   db))

(rf/reg-event-db
 ::set-view-mode
 [trim-v]
 (fn [db [mode]]
   (cond-> db
     true (assoc-in model/view-mode-full-path mode)
     (= mode :list) (p/dissoc-in model/touched-fields-full-path)
     (= mode :list) (p/dissoc-in model/show-all-errors-full-path))))

(rf/reg-event-db
 ::set-selected-config-id
 [trim-v]
 (fn [db [id]]
   (assoc-in db model/selected-config-id-full-path id)))

(rf/reg-event-fx
 ::edit-config
 [inject-tenant-interceptor trim-v]
 (fn [{:keys [db tenant]} [config-id]]
   (let [config (->> (get-in db model/configs-full-path)
                     (cu/find-one :db/id config-id))
         default-config? (= (:tenant/default-login-page-config tenant) config-id)
         config (assoc config :default-config? default-config?)]
     {:db (-> db
              (assoc-in model/form-config-full-path config)
              (assoc-in model/new-config?-full-path false)
              (assoc-in model/login-path-conflict?-full-path false)
              (assoc-in model/selected-config-id-full-path (:db/id config))
              (assoc-in model/touched-fields-full-path #{})
              (assoc-in model/view-mode-full-path :edit))})))

(rf/reg-event-db
 ::open-creator
 [trim-v]
 (fn [db _]
   (let [existing-configs (get-in db model/configs-full-path)]
     (-> db
         (assoc-in model/form-config-full-path (model/create-default-form-config existing-configs))
         (assoc-in model/new-config?-full-path true)
         (assoc-in model/login-path-conflict?-full-path false)
         (assoc-in model/selected-config-id-full-path nil)
         (assoc-in model/touched-fields-full-path #{})
         (assoc-in model/view-mode-full-path :edit)))))

(rf/reg-event-db
 ::set-field-touched
 [trim-v]
 (fn [db [field]]
   (update-in db model/touched-fields-full-path (fnil set/union #{}) #{field})))

(rf/reg-event-db
 ::update-field
 [trim-v]
 (fn [db [field value]]
   (let [path? (= :login-page-config/path field)
         value (if path?
                 (cu/str-trim-lcase value)
                 value)]
     (cond-> db
       true (assoc-in (conj model/form-config-full-path field) value)
       path? (assoc-in model/login-path-conflict?-full-path false)))))

(rf/reg-event-fx
 ::save-config
 [inject-tenant-interceptor trim-v]
 (fn [{:keys [db tenant]}]
   (let [prev-default-login-page (:tenant/default-login-page-config tenant)
         config (get-in db model/form-config-full-path)
         new? (nil? (:db/id config))
         config  (update config :login-page-config/sso-login-methods set)
         body    (if new?
                   (merge config {:entity/type :entity.type/login-page-config})
                   (let [original (->> (get-in db model/configs-full-path)
                                       (cu/find-one :db/id (:db/id config)))
                         changes (->> config
                                      (filterv (fn [[field new-value]]
                                                 (not= (get original field) new-value)))
                                      (into {}))
                         changes (dissoc changes :default-config?)]
                     {:db/id (:db/id config)
                      :data  changes}))
         set-as-default? (and (:default-config? config)
                              (or (not prev-default-login-page)
                                  (not= prev-default-login-page (:db/id config))))
         retract-as-default? (and (not (:default-config? config))
                                  prev-default-login-page
                                  (= prev-default-login-page (:db/id config)))
         ws-id   (if new?
                   :entity/create-entity
                   :entity/update-attributes)]
     {::ws/send {:id         ws-id
                 :body       body
                 :on-success [::save-config-success {:config-id (when-not new?
                                                                  (:db/id config))
                                                     :set-as-default? set-as-default?
                                                     :retract-as-default? retract-as-default?}]
                 :on-error   [::save-config-error]}})))

(rf/reg-event-fx
 ::save-config-success
 [inject-tenant-interceptor trim-v]
 (fn [{:keys [tenant]} [{:keys [config-id set-as-default? retract-as-default?]} resp]]
   (let [config-id (or config-id (-> resp :body :db/id))
         tenant-id (:db/id tenant)]
     (if (or set-as-default?
             retract-as-default?)
       {::ws/send {:id :tenant/update
                   :body {:db/id tenant-id
                          :tenant/default-login-page-config (if set-as-default?
                                                              config-id
                                                              nil)}
                   :on-success [::save-config-success {}]
                   :on-error   [::save-config-error tenant-id]}}

       {:fx [[:dispatch [::set-view-mode :list]]
             [:dispatch [::set-selected-config-id nil]]
             [:dispatch [::load-configs]]]}))))

(rf/reg-event-fx
 ::save-config-error
 [trim-v]
 (fn [{:keys [db]} [resp]]
   (let [{:keys [message client-friendly-error-data]} resp
         is-new? (get-in db model/new-config?-full-path)
         path-conflict? (and (= message (loc/tr :unique-conflict))
                             (-> client-friendly-error-data
                                 :attribute
                                 (= :login-page-config/path)))]
     (js/console.log "save config error " resp)
     {:db (-> db
              (assoc-in model/login-path-conflict?-full-path path-conflict?)
              (assoc-in model/show-all-errors-full-path true))
      ::toast/error (loc/tr (if is-new?
                              :saving-failed
                              :update-failed))})))

(rf/reg-event-db
 ::cleanup
 (fn [db]
   (p/dissoc-in db model/root-path)))
